/* eslint-disable no-unused-vars */
import _ from 'lodash';
import domains from '../containers/Domains';
import { getLocalStorageDataOrFetch } from './fbCallManager';

import { productCatalogIds as nuCatalogIds } from './../constants/nissan-united';

const endpoint = domains.fbEndpoint;

export const getProductCatalogs = async (
  accessToken,
  businessId = '1069169469786223',
  userGroup
) => {
  // At the time of writing this api call, there is only one business account (ConstellationAgency).
  const parameters = {
    accessToken,
    businessId,
    fields: 'id,name',
    limit: 2000
  };

  const query = _.template(
    `${endpoint}<%=businessId%>/owned_product_catalogs?fields=<%=fields%>&access_token=<%=accessToken%>&limit=<%=limit%>`
  );
  const queryString = query(parameters);

  const jsonResult = await getLocalStorageDataOrFetch(queryString);

  const catalogs = jsonResult ? jsonResult.data : [];
  let finalCatalogs = catalogs;

  // switch case leaves room for expansion to other clients in the future
  switch (userGroup) {
    case 'NU':
      finalCatalogs = catalogs.filter((catalogObj) =>
        nuCatalogIds.includes(`${catalogObj.id}`)
      );
      break;
    default:
      break;
  }

  return { ...jsonResult, data: finalCatalogs };
};

export const getProductSets = async (accessToken, productCatalogId) => {
  const parameters = {
    accessToken,
    productCatalogId,
    fields: 'id,name,product_catalog',
    limit: 2000
  };

  const query = _.template(
    `${endpoint}<%=productCatalogId%>/product_sets?fields=<%=fields%>&access_token=<%=accessToken%>&limit=<%=limit%>`
  );
  const queryString = query(parameters);

  let jsonResult = await getLocalStorageDataOrFetch(queryString);

  // some product sets do not have vehicles connected, resulting in errors
  const { error } = jsonResult || {};
  if (error) {
    parameters.fields = 'id,name,product_catalog';
    const queryStringWithoutVehicles = query(parameters);
    jsonResult = await getLocalStorageDataOrFetch(queryStringWithoutVehicles);
  }
  return jsonResult;
};



// WEBPACK FOOTER //
// ./src/fbApi/ProductCatalog.js